import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import useScrollAnimation from "../../hooks/UseScrollAnimation";
import { useState, useEffect } from "react";
import axios from "axios";
export default function TeamSection() {
    const { t, i18n } = useTranslation();
    useScrollAnimation();

    const [dataTeam, setDataTeam] = useState([]);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const respons = await axios.get("https://laravel-api.alnujoud-jo.com/api/members");
                setDataTeam(respons.data.data)
            }
            catch (error) {
                console.error("Error When Fetch Data : ", error)
            }
        }
        fetchData();
    }, [])

    const getLocalizedText = (key) => {
        return i18n.language === 'ar' ? key.A : key.E;
    };

    const showData = dataTeam.slice(0, 3).map((el, index) =>
        <div key={index} className="w-100 w-[32%] shadow-[0px_0px_10px_#00000017] rounded-[8px]">
            <div className="w-full h-[300px]">
                <img className="w-[100%] h-[100%] border-b-[3px] border-[#017e89] rounded-t-[8px]" src={el.image} alt="" />
            </div>
            <div className="p-[20px] flex flex-col justify-between gap-[25px]">
                <div>
                    <div className="font-bold text-[#017E89] text-[20px] capitalize">
                        {t(getLocalizedText({ A: el.name_ar, E: el.name_en }))}
                    </div>
                    <div className="capitalize">
                        {t(getLocalizedText({ A: el.job_title_ar, E: el.job_title_en }))}
                    </div>
                </div>
                <Link
                    to={`/teamDetails/${el.id}`}>
                    <span className="capitalize font-bold">{t("view profile")}</span>
                    <img className="h-auto" src={require("../../assets/icons/twoLines.svg").default} alt="" />
                </Link>
            </div>
        </div>
    )
    return (
        <section className="relative py-[40px]">
            <div className="flex flex-col items-center justify-center mx-auto w-fit">
                <div className="js-scroll fade-top w-[90px] h-[30px]">
                    <img className="w-[100%] h-[100%]" src={require("../../assets/icons/lineMainTitle.svg").default} alt="" />
                </div>
                <div className="js-scroll fade-btm text-[35px] font-bold uppercase text-[#017E89]">{t("Our Team")}</div>
                <span className="js-scroll fade-btm w-[50%] bg-[#017E89] h-[3px]"></span>
            </div>
            <div className="container flex flex-col gap-[15px] items-center py-[20px]">
                <div className="w-full f-col flex flex-wrap gap-[20px]">
                    {showData}
                </div>
                <Link className="js-scroll fade-btm bg-[#017E89] w-fit px-[30px] py-[7px] rounded-[4px] text-white font-bold capitalize" to={"/team"}>{t("Show More")}</Link>
            </div>
        </section>
    );
}